
import $ from 'jquery'
import 'bootstrap'
window.$ = $
window.jQuery = $

